module.exports = __webpack_public_path__ + "img/nav_bar_line.a862e664.svg";